import React, { PropsWithChildren, useEffect } from 'react'
import { PylonProvider } from './PylonContext'

export const VendorAddons: React.FC<PropsWithChildren> = ({ children }) => {
  useEffect(() => {
    // Initialize Appcues
    if (window && window.flatfile.configService.get('VITE_APPCUES_ID')) {
      ;(window as any).AppcuesSettings = { enableURLDetection: true }

      const appcuesScript = document.createElement('script')
      appcuesScript.src = `//fast.appcues.com/${window.flatfile.configService.get('VITE_APPCUES_ID')}.js`
      document.head.appendChild(appcuesScript)
    }
  }, []) // Empty dependency array ensures this effect runs only once on mount

  return <PylonProvider>{children}</PylonProvider>
}
